import {AsyncInlineError, tracer} from '@s-ui/decorators'
import {UseCase} from '@s-ui/domain'

import {GenericUserError} from '../../user/Errors/GenericUserError.js'
import UserServicesFactory from '../../user/Services/factory.js'
import {DeleteUserAdUserAdsError} from '../Errors/DeleteUserAdUserAdsError.js'
import {HTTPUserAdsRepository} from '../Repositories/HTTPUserAdsRepository.js'

class DeleteUserAdUserAdsUseCase extends UseCase {
  #config
  #getCurrentUserService
  #repository

  static create({config}) {
    return new DeleteUserAdUserAdsUseCase({config})
  }

  constructor({config}) {
    super()
    this.#config = config
    this.#getCurrentUserService = UserServicesFactory.getCurrentUserService({config: this.#config})
    this.#repository = HTTPUserAdsRepository.create({config: this.#config})
  }

  @tracer({metric: 'DeleteUserAdUserAdsUseCase#execute'})
  @AsyncInlineError()
  async execute({adId} = {}) {
    const userEntity = await this.#getCurrentUserService.execute()
    if (!userEntity) {
      return Promise.reject(
        GenericUserError.create({message: '[DeleteUserAdUserAdsUseCase#execute] User must be logged'})
      )
    }

    const [error] = await this.#repository.deleteUserAd({userEntity, adId})

    if (error) return Promise.reject(DeleteUserAdUserAdsError.create(error.message))

    return true
  }
}

export const factory = DeleteUserAdUserAdsUseCase.create
